<template>
<div>
  <section class="relative">
    <background />
    <container>
      <h1>Service Offerings</h1>
      <br>
      <span>
        MIT Services provides enhanced and specialist capability and services
        to multi-national, SME, government and corporate orgnisations where they
        either lack or require additional skills and support staff. <br /> <br />
        Our value-add to any solution we supply is in-depth knowledge of the product/s
        and the associated services attached. This means that we bring together
        the relevant skills and certifications to be able to support the customer
        under our commitment to best practices.
      </span>
      <spacer />
      <div v-for="(item, index) in serviceList" :key="index">
        <accordian @change="change" :title="item.title" :description="item.description" :leftTitle="item.leftTitle" :rightTitle="item.rightTitle" :left="item.left" :right="item.right" :thisIndex="index" :currentIndex="currentIndex" />
      </div>
    </container>
    <spacer />
  </section>
  <wwd />
</div>
</template>

<script>
import serviceList from '../json/services';
import accordian from '../components/accordian';
import wwd from './what-we-do';
export default {
  name: 'services',
  data () {
    return {
      serviceList,
      currentIndex: 0
    }
  },
  components: {
    accordian,
    wwd
  },
  methods: {
    change(indexChange) {
      this.currentIndex = indexChange;
    }
  }
}
</script>

<style scoped>
  section {
    display: inline-block;
  }
  .background {
    background-image: url('../assets/background/circuits.jpg');
  }
</style>